import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

export interface ModelOption {
  label: string;
  value: number;
}

@Component({
  selector: 'app-model-selector',
  templateUrl: './model-selector.component.html',
  styleUrls: ['./model-selector.component.scss']
})
export class ModelSelectorComponent implements OnInit {
  @Input() modelCount: number = 3; // Number of models to display (e.g., 5 for Model A through Model E)
  @Input() defaultValue: number = 1; // Default selected model (0-indexed)
  @Input() label: string = 'Select Model'; // Label for the dropdown
  @Output() modelSelected = new EventEmitter<number>();

  modelOptions: ModelOption[] = [];
  selectedModel: number = 1;

  ngOnInit(): void {
    this.generateModelOptions();
    this.selectedModel = this.defaultValue;
  }

  private generateModelOptions(): void {
    this.modelOptions = [];
    const startCharCode = 'A'.charCodeAt(0);
    
    for (let i = 0; i < this.modelCount; i++) {
      const letter = String.fromCharCode(startCharCode + i);
      this.modelOptions.push({
        label: `Model ${letter}`,
        value: i
      });
    }
  }

  onModelChange(value: number): void {
    this.selectedModel = value;
    this.modelSelected.emit(value);
  }
}
